export const fetchFilterItemOptions = function(params) {
    const { siteId, type } = params;
    return this.axiosIns
        .get(`/api-site/search/center/condition/options`, {
            params: {
                siteId,
                conditionName: (type && type.toLowerCase()) || ''
            }
        })
        .then(res => res.data);
};

export const fetchSearchConf = function(params) {
    return this.axiosIns
        .get('/api-site/search/search-data', {
            params
        })
        .then(data => data.data);
};
export const getFilterType = function(params) {
    return this.axiosIns
        .get('/api-site/search/filterType', {
            params
        })
        .then(data => data.data);
};
export const getDefaultSuggestion = async function() {
    return this.axiosIns.get('/api-site/search/default-suggestion').then(res => res.data);
}
export const fetchSuggestions = function(url, params) {
    return this.axiosIns.get(url, { params });
};

export const translateOptions = function(params) {
    return this.axiosIns
        .post('/api-site/search/translateOptions', params)
        .then(data => data.data?.optionList);
};

export const fetchCenterAllConditions = function(params) {
    return this.axiosIns
        .get(`/api-site/search/center/conditions`, {
            params
        })
        .then(res => res.data);
};
